export enum Font {
    Default = "Ubuntu",
    Advanced = "Racing Sans One",
    Poppins = "Poppins"
}